var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7625 2.63438C7.8125 2.55 7.90312 2.5 8 2.5C8.09688 2.5 8.1875 2.55 8.2375 2.63438L14.4344 12.8125C14.4781 12.8844 14.5 12.9656 14.5 13.0469C14.5 13.2969 14.2969 13.5 14.0469 13.5H1.95312C1.70312 13.5 1.5 13.2969 1.5 13.0469C1.5 12.9625 1.52187 12.8813 1.56562 12.8125L7.7625 2.63438ZM6.48125 1.85312L0.284375 12.0312C0.096875 12.3375 0 12.6875 0 13.0469C0 14.125 0.875 15 1.95312 15H14.0469C15.125 15 16 14.125 16 13.0469C16 12.6875 15.9 12.3375 15.7156 12.0312L9.51875 1.85312C9.19688 1.325 8.62187 1 8 1C7.37813 1 6.80312 1.325 6.48125 1.85312ZM9 11.5C9 11.2348 8.89464 10.9804 8.70711 10.7929C8.51957 10.6054 8.26522 10.5 8 10.5C7.73478 10.5 7.48043 10.6054 7.29289 10.7929C7.10536 10.9804 7 11.2348 7 11.5C7 11.7652 7.10536 12.0196 7.29289 12.2071C7.48043 12.3946 7.73478 12.5 8 12.5C8.26522 12.5 8.51957 12.3946 8.70711 12.2071C8.89464 12.0196 9 11.7652 9 11.5ZM8.75 5.75C8.75 5.33437 8.41562 5 8 5C7.58437 5 7.25 5.33437 7.25 5.75V8.75C7.25 9.16562 7.58437 9.5 8 9.5C8.41562 9.5 8.75 9.16562 8.75 8.75V5.75Z",
    fill: "#EDAC1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.5864eec6fc35c7ba436a3c482f32fea0.svg";
export { ForwardRef as ReactComponent };